<div *ngIf="columnsData" class="res-table-expand-base" fxLayout="column" fxFlex="0 0 100%">
    <app-table-filter-expansion-panel
        [ngClass]="{
            'hide-filters-and-paginator':
                !!usersCountToHideFiltersAndPaginator && totalUsersCount$.value < usersCountToHideFiltersAndPaginator
        }"
        [expanded]="filtersExpanded"
        class="task-expansion"
        #filterExpansion
        [hasTopBorder]="false"
    >
        <ng-content select="[tableFiltersTempl]"></ng-content>
    </app-table-filter-expansion-panel>
    <mat-progress-bar *ngIf="(dataSource.status | async) == 'loading'" mode="indeterminate"></mat-progress-bar>
    <div *ngIf="canSelect && showSelectionActions" class="multi-select">
        <ng-container
            *ngTemplateOutlet="otherContext['multipleSelectionActions']; context: { $implicit: selection.selected }"
        ></ng-container>
    </div>
    <mat-table
        #table
        [dataSource]="dataSource"
        [matSortDirection]="matSortDirection"
        [matSortActive]="matSortActive"
        [class.showSelectionActions]="canSelect && showSelectionActions"
        matSort
        [multiTemplateDataRows]="expandingTable"
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"
                    color="primary"
                >
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let user">
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(user) : null"
                    [checked]="selection.isSelected(user)"
                    [aria-label]="checkboxLabel(user)"
                    color="primary"
                >
                </mat-checkbox>
            </mat-cell>
        </ng-container>
        <ng-container *ngFor="let column of columns">
            <ng-container *ngIf="column != 'select'" [matColumnDef]="column">
                <mat-header-cell
                    [class.notsortable]="!columnsKeys[column]?.sortable"
                    *matHeaderCellDef
                    [mat-sort-header]="columnsKeys[column]?.sortable ? column : null"
                >
                    <mat-icon class="label-icon-header" *ngIf="columnsKeys[column]?.icon">{{
                        columnsKeys[column]?.icon
                    }}</mat-icon>
                    {{ columnsKeys[column]?.label }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <ng-container *ngIf="columnsData[column]">
                        <ng-container
                            *ngTemplateOutlet="columnsData[column]; context: { $implicit: user }"
                        ></ng-container>
                    </ng-container>
                </mat-cell>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="expandingTable" matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let user" [attr.colspan]="columns.length">
                <div class="example-element-detail" [@detailExpand]="expandedFn(user) ? 'expanded' : 'collapsed'">
                    <ng-container
                        *ngTemplateOutlet="otherContext['expansionContext']; context: { $implicit: user }"
                    ></ng-container>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let user; columns: columns"
            (click)="onRowClick.emit(user); expandingTable && toggleExpand(user)"
            class="example-element-row"
            [class.expandedMobileRowId]="expandedFn(user)"
        ></mat-row>
        <ng-container *ngIf="expandingTable">
            <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></mat-row>
        </ng-container>
    </mat-table>
    <mat-paginator
        [ngClass]="{
            'hide-filters-and-paginator':
                !!usersCountToHideFiltersAndPaginator && totalUsersCount$.value < usersCountToHideFiltersAndPaginator
        }"
        [pageSize]="pageSizeOptions[0]"
        [pageSizeOptions]="pageSizeOptions"
    >
    </mat-paginator>
</div>
